import { combineReducers} from 'redux'
import requestRducer from './requests_reducers'

export const rootReducer = combineReducers({requestRducer})